export default __webpack_public_path__ + "static/media/logo.2df9e3d0.png";